module.exports = __webpack_public_path__ + "img/cyan1.0b822397.jpg";